import { render, staticRenderFns } from "./PurchaseOrderMisc.vue?vue&type=template&id=f16f3826&scoped=true"
import script from "./PurchaseOrderMisc.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderMisc.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderMisc.vue?vue&type=style&index=0&id=f16f3826&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16f3826",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f16f3826')) {
      api.createRecord('f16f3826', component.options)
    } else {
      api.reload('f16f3826', component.options)
    }
    module.hot.accept("./PurchaseOrderMisc.vue?vue&type=template&id=f16f3826&scoped=true", function () {
      api.rerender('f16f3826', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchaseorder/PurchaseOrderMisc.vue"
export default component.exports